import websocketApi from "./websocketApi"
import isInPosDevice from "./isInPosDevice"
import RNWebViewApi from "./RNWebViewApi"

const webViewExectuer = async (resolve, reject, requestBody) => {
  const response =
    await RNWebViewApi.postMessage(requestBody)

  response.error
    ? reject(response.errorMessage)
    : resolve(response.data)
}

const webSocketExecuter = async (resolve, reject, requestBody) => {
  try {
    const response =
      await websocketApi.send(requestBody)

    resolve(response)
  } catch (err) {
    reject(err)
  }
}

const ipcApi = (requestBody) => (
  new Promise((resolve, reject) => {
    if (isInPosDevice()) {
      return webViewExectuer(resolve, reject, requestBody)
    }

    return webSocketExecuter(resolve, reject, requestBody)
  })
)

export default ipcApi